export default __webpack_public_path__ + "static/media/cameraSelected.957e51c2.svg";